<template>
  <div class="container is-fluid">
    <h1 class="title">Erweiterte Suche</h1>
    <SearchGroup v-for="group in searchGroups" v-bind:key="group.id" v-bind:group="group"></SearchGroup>
    <div class="columns">
      <div class="column">
        <div class="search-controls">
          <button v-on:click="addGroup" class="button">Neue Gruppe</button>
          <button
            class="button is-primary is-pulled-right"
            v-on:click="advancedSearch"
          >Suche starten</button>
        </div>
      </div>
    </div>
    <div class="columns is-multiline" ref="imageList">
      <div class="column is-3" v-for="image in searchResult" :key="image.id">
        <ImageCard v-bind:imageId="image.id" />
      </div>
    </div>
    <nav
      v-if="searchResult.length > 0"
      class="pagination"
      role="navigation"
      aria-label="pagination"
    >
      <a class="pagination-previous" v-on:click="scrollToTopAndGotoPage(page-1)">Previous</a>
      <a class="pagination-next" v-on:click="scrollToTopAndGotoPage(page+1)">Next page</a>
      <ul class="pagination-list">
        <li v-if="page>1">
          <a class="pagination-link" aria-label="Goto page 1"  v-on:click="scrollToTopAndGotoPage(0)">1</a>
        </li>
        <li v-if="page>1">
          <span class="pagination-ellipsis">&hellip;</span>
        </li>
        <li v-if="page>0">
          <a class="pagination-link" :aria-label="'Go to page ' + page" v-on:click="scrollToTopAndGotoPage(page-1)">{{page}}</a>
        </li>
        <li>
          <a class="pagination-link is-current" :aria-label="'Page ' + (page+1)" aria-current="page">{{page+1}}</a>
        </li>
        <li v-if="page<pages-2">
          <a class="pagination-link" :aria-label="'Go to page ' + (page+2)" v-on:click="scrollToTopAndGotoPage(page+1)">{{page+2}}</a>
        </li>
        <li v-if="page<pages-2">
          <span class="pagination-ellipsis">&hellip;</span>
        </li>
        <li v-if="page<pages-1">
          <a class="pagination-link" :aria-label="'Go to page ' + pages" v-on:click="scrollToTopAndGotoPage(pages-1)">{{pages}}</a>
        </li>
      </ul>
    </nav>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import ImageCard from "../components/ImageCard.vue";
import SearchGroup from "../components/SearchGroup.vue";

export default {
  computed: mapState("search", [
    "searchResult",
    "pages",
    "page",
    "searchGroups",
    "conjunctive",
    "groupCount",
  ]),
  components: {
    ImageCard,
    SearchGroup,
  },
  methods: {
    addGroup() {
      this.$store.commit("search/newGroup");
    },
    scrollToTopAndGotoPage(page) {
      this.$refs.imageList.scrollIntoView()
      this.gotoPage(page)
    },
    ...mapActions("search", ["advancedSearch", "gotoPage"]),
  },
};
</script>
